document.documentElement.classList.remove("no-js");
document.documentElement.classList.add("js");

const initLoader = () => {
  const loader = document.querySelector(".loader");
  if (!loader || loader.dataset.bound === "true") return;
  loader.dataset.bound = "true";
  const count = loader.querySelector(".loader__count");
  const track = loader.querySelector(".loader__track span");
  let progress = 0;
  const timer = window.setInterval(() => {
    progress = Math.min(100, progress + 18);
    if (count) count.textContent = String(progress).padStart(3, "0");
    if (track) track.style.width = `${progress}%`;
    if (progress === 100) {
      window.clearInterval(timer);
      window.setTimeout(() => loader.classList.add("is-done"), 120);
    }
  }, 55);
};

const initReveals = (scope = document) => {
  const items = scope.querySelectorAll(".reveal:not([data-reveal-bound])");
  if (!("IntersectionObserver" in window)) {
    items.forEach((item) => item.classList.add("is-visible"));
    return;
  }
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add("is-visible");
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.08 });
  items.forEach((item) => {
    item.dataset.revealBound = "true";
    observer.observe(item);
  });
};

const initHeader = (scope = document) => {
  scope.querySelectorAll("[data-menu-toggle]:not([data-bound])").forEach((button) => {
    button.dataset.bound = "true";
    const panel = document.getElementById(button.getAttribute("aria-controls"));
    if (!panel) return;
    const close = () => {
      panel.classList.remove("is-open");
      panel.setAttribute("aria-hidden", "true");
      button.setAttribute("aria-expanded", "false");
      document.body.classList.remove("is-locked");
    };
    button.addEventListener("click", () => {
      const opening = !panel.classList.contains("is-open");
      panel.classList.toggle("is-open", opening);
      panel.setAttribute("aria-hidden", String(!opening));
      button.setAttribute("aria-expanded", String(opening));
      document.body.classList.toggle("is-locked", opening);
    });
    panel.querySelectorAll("a").forEach((link) => link.addEventListener("click", close));
    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && panel.classList.contains("is-open")) {
        close();
        button.focus();
      }
    });
  });
};

const initProductFilters = (scope = document) => {
  scope.querySelectorAll("[data-product-filter]:not([data-bound])").forEach((root) => {
    root.dataset.bound = "true";
    const cards = Array.from(root.querySelectorAll("[data-product-card]"));
    const count = root.querySelector("[data-visible-count]");
    root.querySelectorAll("[data-filter]").forEach((button) => {
      button.addEventListener("click", () => {
        root.querySelectorAll("[data-filter]").forEach((item) => item.classList.remove("is-active"));
        button.classList.add("is-active");
        const filter = button.dataset.filter.toLowerCase();
        let visible = 0;
        cards.forEach((card) => {
          const tags = (card.dataset.productTags || card.dataset.category || "")
            .toLowerCase()
            .split(",")
            .map((tag) => tag.trim());
          const show = filter === "all" || tags.includes(filter);
          card.hidden = !show;
          if (show) visible += 1;
        });
        if (count) count.textContent = String(visible).padStart(2, "0");
      });
    });
  });
};

const initCraft = (scope = document) => {
  scope.querySelectorAll(".system:not([data-bound])").forEach((root) => {
    root.dataset.bound = "true";
    root.querySelectorAll("[data-detail-target]").forEach((button) => {
      button.addEventListener("click", () => {
        root.querySelectorAll("[data-detail-target]").forEach((item) => item.classList.remove("is-active"));
        button.classList.add("is-active");
        const id = root.querySelector("[data-detail-id]");
        const title = root.querySelector("[data-detail-title]");
        const copy = root.querySelector("[data-detail-copy]");
        if (id) id.textContent = button.dataset.detailId;
        if (title) title.textContent = button.dataset.detailTitle;
        if (copy) copy.textContent = button.dataset.detailCopy;
      });
    });
  });
};

const initCampaign = (scope = document) => {
  scope.querySelectorAll(".field:not([data-bound])").forEach((root) => {
    root.dataset.bound = "true";
    const image = root.querySelector(".field__media img");
    root.querySelectorAll("[data-campaign-position]").forEach((button) => {
      button.addEventListener("click", () => {
        root.querySelectorAll("[data-campaign-position]").forEach((item) => item.classList.remove("is-active"));
        button.classList.add("is-active");
        if (image) {
          image.style.objectPosition = button.dataset.campaignPosition;
          image.style.filter = "none";
        }
      });
    });
  });
};

const initBackToTop = (scope = document) => {
  scope.querySelectorAll("[data-back-top]:not([data-bound])").forEach((button) => {
    button.dataset.bound = "true";
    button.addEventListener("click", () => window.scrollTo({ top: 0, behavior: "smooth" }));
  });
};

const initPasswordToggle = (scope = document) => {
  scope.querySelectorAll("[data-password-toggle]:not([data-bound])").forEach((button) => {
    button.dataset.bound = "true";
    const input = document.getElementById(button.getAttribute("aria-controls"));
    if (!input) return;
    button.addEventListener("click", () => {
      const showing = input.type === "text";
      input.type = showing ? "password" : "text";
      button.textContent = showing ? "SHOW" : "HIDE";
      button.setAttribute("aria-label", showing ? "Show password" : "Hide password");
    });
  });
};

const initTheme = (scope = document) => {
  initReveals(scope);
  initHeader(scope);
  initProductFilters(scope);
  initCraft(scope);
  initCampaign(scope);
  initBackToTop(scope);
  initPasswordToggle(scope);
};

initLoader();
initTheme();

const stickyHeader = document.querySelector(".site-header");
if (stickyHeader) {
  window.addEventListener("scroll", () => {
    stickyHeader.classList.toggle("is-sticky", window.scrollY > 40);
  }, { passive: true });
}

document.addEventListener("shopify:section:load", (event) => initTheme(event.target));
